import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./ChangeUnit.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
//service

import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import {
  addLeadLogs,
  getProjects,
  updateLeadAllStatus,
} from "../../Services/Lead";
import {
  getBookingAmount,
  getInventory,
  getInventoryExceptSelectedOne,
  getInventoryStatusId,
  getInventoryStatusStringFromId,
  updateAllotmentTransactions,
  updateAllotmentUnitId,
  updateInventoryStatus,
  freeAndZeroInventoryForChangeUnit,
} from "../../Services/ChangeUnit";
import {
  getAllotedData,
  changeAllotedUnit,
  checkForChangeUnitStatus,
  updateAllotmentPaymentStatus,
  getDataFromInventory,
  getAllotedDataInChangeUnit,
  getPendingChangeUnitRequestsByAllotment,
} from "../../Services/AlotUnit";
import { sortBy, uniqBy } from "lodash";
import { sendMailTo, sendMessage } from "../../Services/SmsService";
import { Network } from "@capacitor/network";
import {
  getApproverInHierarchy,
  getSuperAdminId,
} from "../../Services/LoginService";
import { insertInventoryLogs, updateCrmByAllotmentPaymentId } from "../../Services/AllAllotments";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { getAllInventoryStatusFromTable } from "../../Services/SustenanceService";
import { bucketingForChangeUnit } from "../../Services/PaymentApi";
import { getInventoryTypeId } from "../../Services/Inventory";
import { getAllPaymentPlans } from "../../Services/PaymentPlans";
import { checkForInventoryStatus, updateChangeUnitRequest } from "../../Services/Event";
import { getPaymentPlansPriceFromServer } from "../../Services/Project";
import { getProjectDataByProjectId } from "../../Services/FastBooking";

// Unit-shift eligibility: branches on whether the allotment is CRM-tagged (has a
// CRM row). Non-CRM allotments are gated on status + preselect rules; CRM-tagged
// ones are gated on applicationApiRes/bookingId only (their sales steps are already
// complete, so status/preselect no longer apply). B2B-flagged allotments are always
// blocked regardless of branch.
function computeChangeUnitEligibility(row) {
  const b2bBlocked = !!(row?.["100B2bRes"] || row?.gstB2bRes || row?.SdrB2bRes);
  const isCrmTagged = (row?.CRM?.length || 0) > 0;

  if (b2bBlocked) {
    return { isAllowed: false, isCrmTagged, b2bBlocked };
  }

  if (isCrmTagged) {
    const isAllowed = row?.applicationApiRes == null && row?.bookingId == null;
    return { isAllowed, isCrmTagged, b2bBlocked };
  }

  const statusOk = ["Payment Complete", "Partial Payment Done", "Payment Pending"].includes(row?.status);
  if (!statusOk) {
    return { isAllowed: false, isCrmTagged, b2bBlocked };
  }

  if (row?.pricingType === "preselect") {
    const confirmation = row?.preselectConfirmation;
    if (confirmation === "confirmation pending" || confirmation === "payment pending") {
      return { isAllowed: false, isCrmTagged, b2bBlocked };
    }
    const endDateTime = row?.paymentId?.eventTokenId?.endDateTime;
    const eventClosed = endDateTime != null && Date.now() > new Date(endDateTime).getTime();
    return { isAllowed: confirmation === "confirmed" && eventClosed, isCrmTagged, b2bBlocked };
  }

  return { isAllowed: true, isCrmTagged, b2bBlocked };
}

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));

export default function ChangeUnit({
  open,
  handleClose,
  returnRes,
  data,
  selectedAllotment,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  const [projectNameList, setProjectNameList] = useState([]);
  const [inventoryArray, setInventoryArray] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [unitNoList, setUnitNoList] = useState([]);
  const [wingNameList, setWingNameList] = useState([]);
  const [selectedWingNameList, setSelectedWingNameList] = useState([]);
  const [changeUnitData, setChangeUnitData] = useState({
    projectName: "",
    projectData: null,
    unitNo: "",
    unitId: "",
    floorNo: "",
    wingName: "",
    description: "",
    selectedUnitId: "",
    bookingAmt: null,
    unitCost: null,
    paymentPlanId: null,
    enablePaymentPlan: false
  });
  const [ownedUnitData, setOwnedData] = useState({
    projectName: "",
    projectId: "",
    unitId: null,
    unitData: "",
    allotmentPaymentId: "",
    inventoryMergedId: null,
    bookingAmt: null,
    paidAmount: null,
    statusId: null,
    isAllowed: false,
    allotmentStatus: "",
    kycFormFilled: false,
    paymentPlanId: null,
    bookingId: null,
  });
  console.log("owenedUnitData",ownedUnitData);
  
  const [allotedData, setAllotedData] = useState([]);
  const [helperText, setHelperText] = useState({
    projectName: "",
    wingName: "",
    floorNo: "",
    unitNo: "",
    description: "",
    selectedUnit: "",
    paymentPlan: ""
  });
  const [changedBookingAmt, setChangedBookingAmt] = useState(null);
  const [saveBtnTitle, setSaveBtnTitle] = useState("Raise a request");
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [openAlertBox, setOpenAlertBox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasPendingRequest, setHasPendingRequest] = useState(false);
  // Double-submit guard. A ref, not state: two clicks in the same tick would both
  // read a stale `false` off state, which is exactly the duplicate ChangeUnitRequests
  // row this exists to prevent. The state copy is only for disabling the button.
  const isSubmittingRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Returns false if a submit is already running, so callers can bail out.
  function beginSubmit() {
    if (isSubmittingRef.current) return false;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    presentLoader();
    return true;
  }
  function endSubmit() {
    isSubmittingRef.current = false;
    setIsSubmitting(false);
    dismissLoader();
  }
  const [kycPendingInventoryStatus, setKycPendingInventoryStatus] = useState('');
  const [kycDoneInventoryStatus, setKycDoneInventoryStatus] = useState('');
  const [holdInventoryStatus, setHoldInventoryStatus] = useState('');
  const [paymentPendingInventoryStatus, setPaymentPendingInventoryStatus] = useState('');
  const [listOfProjectPaymentPlan, setListOfProjectPaymentPlan] = useState([]);
  const [selectedProjectPaymentPlanId, setSelectedProjectPaymentPlanId] =
    useState('');
  const [selectedProjectPaymentPlan, setSelectedProjectPaymentPlan] =
    useState(null);
  useEffect(() => {
    // getProjects()
    //   .then((resp) => {
    //     console.log(resp);
    //     setProjectNameList(resp);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    getAllotedUnit();
    getAllStatusesFromTable();
  }, []);
  useEffect(() => {
    console.log({ data }, changeUnitData,
      { ownedUnitData },);

  }, [data, changeUnitData]);





  function getAllStatusesFromTable() {
    //*to get inventory-Statuses
    getAllInventoryStatusFromTable()
      .then((resp) => {
        console.log("Inventory=Status", resp);
        const AllotedStatus = resp.data.filter(
          (f) => f.status === "Payment Pending"
        );
        console.log("Alloted-Status", AllotedStatus[0]?.inventoryStatusId);
        setPaymentPendingInventoryStatus(AllotedStatus[0]?.inventoryStatusId);

        const onHoldStatus = resp.data.filter((f) => f.status === "On Hold");
        console.log("on-Hold-Status", onHoldStatus[0]?.inventoryStatusId);
        setHoldInventoryStatus(onHoldStatus[0]?.inventoryStatusId);

        // const onPreSelectStatus = resp.data.filter((f) => f.status === "Preselected");
        // console.log("on-Hold-Status", onPreSelectStatus[0]?.inventoryStatusId);
        // setPreSelectInventoryStatus(onPreSelectStatus[0]?.inventoryStatusId);

        const kycPending = resp.data.filter((f) => f.status === "Kyc Pending");
        setKycPendingInventoryStatus(kycPending[0]?.inventoryStatusId);

        const kycDone = resp.data.filter((f) => f.status === "Kyc Done");
        setKycDoneInventoryStatus(kycDone[0]?.inventoryStatusId);
      })
      .catch((err) => {
        console.error("Inventory=Status", err);
      });

  }
  // A Change Unit request already at 'Pending' for THIS allotment blocks a new one.
  // Same rule, same key (allotmentPaymentId) as the guard inside updateChangeUnit(),
  // so the up-front check and the write-time check can never disagree.
  function checkForPendingRequestOnAllotment(allotmentPaymentId) {
    if (!allotmentPaymentId) {
      setHasPendingRequest(false);
      return;
    }
    getPendingChangeUnitRequestsByAllotment(allotmentPaymentId)
      .then((rows) => {
        setHasPendingRequest((rows ?? []).length > 0);
      })
      .catch((err) => {
        // Fail open. updateChangeUnit() re-runs its own check before writing
        // anything, so a failed pre-check must never lock out a legitimate user.
        console.error("change unit: pending-request pre-check failed", err);
        setHasPendingRequest(false);
      });
  }
  function getAllotedUnit() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllotedDataInChangeUnit(data.leadId)
          .then((allotedData) => {
            console.log({ allotedData });
            let allotedProject = [];
            if (allotedData?.data.length > 0) {
              allotedData?.data.forEach((el) => {
                let object = {
                  label:
                    el?.unitId?.projectId?.projectName ??
                    el?.inventoryMergedId?.projectId?.projectName,
                  value:
                    el?.unitId?.projectId?.projectId ??
                    el?.inventoryMergedId?.projectId?.projectId,
                  enablePaymentPlan:
                    el?.unitId?.projectId?.enablePaymentPlan ??
                    el?.inventoryMergedId?.projectId?.enablePaymentPlan,
                };
                allotedProject.push(object);
              });
              setProjectNameList(uniqBy([...allotedProject], "label"));
              allotedData.data = allotedData.data.map((el) => ({
                ...el,
                unitData: el?.unitId ?? el?.inventoryMergedId?.unit1Id,
                // unitId: el.unitId?.unitId ?? el?.inventoryMergedId?.unit1Id?.unitId,
              }));
              setAllotedData([...allotedData.data]);
              // ! get selectedAllotment index
              let allotmentDataIndex = 0;
              console.log("selectedAllotment: ", selectedAllotment);
              if (selectedAllotment) {
                allotmentDataIndex = allotedData.data.findIndex((data) => {
                  return (
                    data.allotmentPaymentId ===
                    selectedAllotment.allotmentPaymentId
                  );
                });
                const selectedProject = {
                  label:
                    allotedData.data[allotmentDataIndex].unitId.projectId
                      .projectName,
                  value:
                    allotedData.data[allotmentDataIndex].unitId.projectId
                      .projectId,
                };
                const allotedWing = getProjectWiseWings(
                  allotedData.data,
                  selectedProject
                );
                console.log("allotedWing: ", allotedWing);
                setSelectedWingNameList([...allotedWing]);
                setChangeUnitData((pre) => {
                  pre.projectName = selectedProject.value;
                  pre.selectedUnitId =
                    allotedData.data[allotmentDataIndex].unitId.unitId;
                  pre.enablePaymentPlan =
                    allotedData.data[allotmentDataIndex]?.unitId?.projectId?.enablePaymentPlan;
                  return { ...pre };
                });
                console.log('selectedUnitId', allotedWing[0].value)
                getAllInventory(
                  allotedData.data[allotmentDataIndex].unitId.projectId.projectId,
                  allotedData.data[allotmentDataIndex].unitId.unitId
                );
              } else {

                console.log("=======================================")
                const allotedWing = getProjectWiseWings(
                  allotedData.data,
                  uniqBy([...allotedProject], "label")[0]
                );
                console.log("allotedWing: ", allotedWing);
                setSelectedWingNameList([...allotedWing]);
                setChangeUnitData((pre) => {
                  pre.projectName = allotedProject[0].value;
                  pre.selectedUnitId = allotedWing[0].value;
                  pre.enablePaymentPlan = allotedData?.data[allotmentDataIndex]?.unitId?.projectId?.enablePaymentPlan;
                  return { ...pre };
                });
                getAllInventory(allotedProject[0].value, allotedWing[0].value);
              }

              console.log("already alloted data", [...allotedData.data]);
              const eligibility = computeChangeUnitEligibility(allotedData.data[allotmentDataIndex]);
              const isAllowed = eligibility.isAllowed;
              setOwnedData((pre) => {
                pre.allotmentPaymentId =
                  allotedData.data[allotmentDataIndex]?.allotmentPaymentId;
                pre.paymentPlanId =
                  allotedData.data[allotmentDataIndex]?.paymentPlanId;
                pre.projectId =
                  allotedData.data[allotmentDataIndex]?.unitId?.projectId?.projectId;
                pre.projectName =
                  allotedData?.data[
                    allotmentDataIndex
                  ]?.unitId?.projectId?.projectName;
                pre.unitId = allotedData?.data[allotmentDataIndex]?.unitId?.unitId;
                pre.unitData = allotedData?.data[allotmentDataIndex]?.unitData;
                pre.inventoryMergedId =
                  allotedData?.data[allotmentDataIndex]?.inventoryMergedId;
                pre.bookingAmt = allotedData?.data[allotmentDataIndex]?.bookingAmt;
                pre.paidAmount = allotedData?.data[allotmentDataIndex]?.paidAmount;
                pre.statusId =
                  allotedData?.data[allotmentDataIndex]?.unitData?.inventoryStatusId;
                pre.isAllowed = isAllowed;
                pre.isCrmTagged = eligibility.isCrmTagged;
                pre.b2bBlocked = eligibility.b2bBlocked;
                pre.allotmentStatus = allotedData?.data[allotmentDataIndex]?.status;
                pre.pricingType = allotedData?.data[allotmentDataIndex]?.pricingType;
                pre.kycFormFilled = allotedData?.data[allotmentDataIndex]?.kycFormFilled;
                pre.hundredB2bRes = allotedData?.data[allotmentDataIndex]?.["100B2bRes"]
                pre.gstB2bRes = allotedData?.data[allotmentDataIndex]?.gstB2bRes
                pre.SdrB2bRes = allotedData?.data[allotmentDataIndex]?.SdrB2bRes
                  pre.bookingId = allotedData?.data[allotmentDataIndex]?.bookingId;
                console.log("allotedData?.data[allotmentDataIndex]", allotedData?.data[allotmentDataIndex])
                return { ...pre };
              });
              setSelectedLeadId(allotedData.data[allotmentDataIndex].leadId);
              checkForPendingRequestOnAllotment(
                allotedData?.data[allotmentDataIndex]?.allotmentPaymentId
              );
            } else {
              setProjectNameList(['No Projects Available']);
              setSelectedWingNameList(['No Units Available']);
              setErrorMessage('No Units Available to Change');
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }
  function getProjectWiseWings(allotedData, project) {
    console.log("project: ", project);
    let allotedWings = [];
    const allWings = allotedData.filter((data) => {
      if (
        (data.unitId && data.unitId.projectId.projectId === project.value) ||
        (data.inventoryMergedId &&
          data.inventoryMergedId.unit1Id.projectId.projectId === project.value)
      ) {
        return data;
      }
    });
    for (let el of allWings) {
      let allotedUnitObject = {};
      if (el?.inventoryMergedId == null) {
        allotedUnitObject = {
          label: el.unitId?.wingId?.wingName + "-" + el.unitId?.unitNo,
          value: el.unitId?.unitId,
        };
        // el.unitId = el?.unitId
      } else {
        allotedUnitObject = {
          label:
            el?.inventoryMergedId?.unit1Id?.wingId?.wingName +
            "-" +
            el?.inventoryMergedId?.unit1No +
            "-" +
            el?.inventoryMergedId?.unit2No,
          value:
            el?.inventoryMergedId?.unit1Id?.unitId +
            "-" +
            el?.inventoryMergedId?.unit2No,
        };
        el.unitId = el?.inventoryMergedId?.inventoryMergeId;
        // el.unitId = el?.inventoryMergedId?.unit1Id
        // el.unitId = el?.inventoryMergedId?.unit1Id?.unitId
      }

      allotedWings.push(allotedUnitObject);
    }
    return uniqBy(allotedWings, "value");
  }
  function getAllInventory(projectId, selectedUnitId) {
    console.log(projectId, selectedUnitId);
    Network.getStatus().then((status) => {
      if (status.connected) {
        getInventoryExceptSelectedOne(projectId, selectedUnitId)
          .then((resp) => {
            console.log("Inventory", resp);
            setInventoryArray(resp);
            const wingName = [
              ...new Set(resp.map((item) => item.wingId.wingName)),
            ];
            console.log(wingName);
            setWingNameList(wingName);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        offlineToast();
      }
    });
  }
  function getChangedBookingAmount(projectId, wingId, unitTypeId) {
    return new Promise((resolve, reject) => {
      let bookingAmt = null;
      Network.getStatus().then((status) => {
        if (status.connected) {
          getBookingAmount(projectId, wingId, unitTypeId)
            .then((resp) => {
              console.log("Booking amount", resp);
              if (resp && resp.length > 0) {
                bookingAmt = resp[0];
                setChangedBookingAmt(resp[0]);
              }
              resolve(bookingAmt);
            })
            .catch((err) => {
              reject(bookingAmt);
              console.log(err);
            });
        } else {
          resolve(bookingAmt);
          offlineToast();
        }
      });
    });
  }
  function filterFloors(wingName) {
    let test = inventoryArray.filter((value) => {
      // console.log(value);
      return value.wingId.wingName === wingName;
    });
    console.log("console", uniqBy(test, "floorNo"));
    setFloorList(uniqBy(test, "floorNo"));
  }
  function filterUnit(floorNo, wingName) {
    console.log({ inventoryArray });
    let uniqueUnitNo = inventoryArray.filter((value) => {
      // console.log(value);
      return value.floorNo === floorNo && value.wingId.wingName === wingName;
    });
    console.log(uniqueUnitNo);
    setUnitNoList(uniqueUnitNo);
  }

  function validateAllMandatoryFields() {
    var form = true;
    if (changeUnitData.projectName === "") {
      form = false;
      setHelperText((pre) => {
        pre.projectName = "Please select project";
        return { ...pre };
      });
    }
    if (changeUnitData.selectedUnitId === "") {
      form = false;
      setHelperText((pre) => {
        pre.selectedUnit = "Please select Unit";
        return { ...pre };
      });
    }
    if (changeUnitData.wingName === "") {
      form = false;
      setHelperText((pre) => {
        pre.wingName = "Please select wing";
        return { ...pre };
      });
    }
    if (changeUnitData.floorNo === "") {
      form = false;
      setHelperText((pre) => {
        pre.floorNo = "Please select floor";
        return { ...pre };
      });
    }
    if (changeUnitData.unitNo === "") {
      form = false;
      setHelperText((pre) => {
        pre.unitNo = "Please select unit";
        return { ...pre };
      });
    }
    if (changeUnitData.description === "") {
      form = false;
      setHelperText((pre) => {
        pre.description = "Please enter description";
        return { ...pre };
      });
    }
    if (selectedProjectPaymentPlanId === "" && changeUnitData?.enablePaymentPlan) {
      form = false;
      setHelperText((pre) => {
        pre.paymentPlan = "Please select payment plan";
        return { ...pre };
      });
    }
    return {
      flag: form,
    };
  }

  async function sendMailAndSms(email, subject) {
    let message = `<h4>You have requested to change your Unit.</h4>
            <p>Current Unit: <b>${ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}</b></p></br>
            <p>Request Change Unit: <b>${changeUnitData?.displayName ? changeUnitData?.displayName : changeUnitData?.wingName}-${changeUnitData?.unitNo}</b></p></br>
            <p>Request was done under <b>${data?.Sales?.name}</b></p>
            <p>Are you sure you want to change your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;
    // let message = `<h4>You have requested to change your Unit.</h4>
    //         <p>Current Unit: <b>${ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}</b></p></br>
    //         <p>Request Change Unit: <b>${changeUnitData?.wingName}-${changeUnitData?.unitNo}</b></p></br>
    //         <p>Request was done under <b>${data?.Sales?.name}</b></p>
    //         <p>Are you sure you want to change your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}</p>`;
    let emailbody = {
      to: [email],
      subject: subject,
      message: message,
    };
    // let messageBody = {
    //   number: "+" + 919823140243,
    //   message: `You have requested to change your Unit.Current Unit:${ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}.Request Change Unit:${changeUnitData?.wingName}-${changeUnitData?.unitNo}.Request was done under${data?.Sales?.name}.Are you sure you want to change your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}`,
    //   is_international_number: true,
    //   // copyLeadObj?.leadcontactnumber.toString().substring(0, 2) !== "91"
    //   //     ? true
    //   //     : false,
    // };
    let messageBody = {
      number: "+" + 919823140243,
      message: `You have requested to change your Unit.Current Unit:${ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName}-${ownedUnitData?.unitData?.unitNo}.Request Change Unit:${changeUnitData?.displayName ? changeUnitData?.displayName : changeUnitData?.wingName}-${changeUnitData?.unitNo}.Request was done under${data?.Sales?.name}.Are you sure you want to change your unit?To confirm cancellation, click on ${process.env.REACT_APP_CUSTOMER_PORTAL}`,
      is_international_number: true,
      // copyLeadObj?.leadcontactnumber.toString().substring(0, 2) !== "91"
      //     ? true
      //     : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        return false;
      });
    const emailRes = await sendMailTo(emailbody)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }
  // function save() {
  //   console.log(
  //     changeUnitData,
  //     { ownedUnitData },
  //     ownedUnitData?.inventoryMergedId?.inventoryMergeId
  //   );
  //   let flag = validateAllMandatoryFields();
  //   if (flag.flag) {
  //     //queryCall
  //     setOpenAlertBox(true);
  //   }
  // }


function save() {
  console.log(changeUnitData, { ownedUnitData });

  let flag = validateAllMandatoryFields();

  if (flag.flag) {
    setOpenAlertBox(true);
  }
}

  function confirmationRes(resp) {
    if (resp === "confirmed") {
      // The Warning dialog closes itself, but this modal stays open for the whole
      // write chain. Without a loader there is no feedback, so the user presses
      // "Raise a request" again and gets a second ChangeUnitRequests row.
      if (!beginSubmit()) return;
      updateChangeUnit();
    }
  }
  function updateChangeUnit() {
    Network.getStatus().then((status) => {
      if (status.connected) {

        // !todo 1. check if loggedInUser is superadmin or an approver for change unit requests
        // !todo 2. if yes, directly change units & respective statuses
        // !todo 3. if no, raise a request
        // ! vedashree to change below condition
        // if (loggedInUser.roleId.level === 1 || loggedInUser.roleId.accessibleTabs['Leads']['Allotment']['Change unit'].requestType.show === 'Approve' || loggedInUser.roleId.accessibleTabs['Leads']['All']['Change unit'].requestType.show === 'Approve') {
      if (
  loggedInUser?.roleId?.level === 1 ||
  loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["Change Unit Approver"]
)
 {
          checkForChangeUnitStatus(
            ownedUnitData.unitId,
            ownedUnitData?.inventoryMergedId?.inventoryMergeId,
            ownedUnitData?.allotmentPaymentId
          ).then((resp) => {
            console.log(resp);
            resp.data = resp.data.filter(
              ({ allotmentPaymentId }) => allotmentPaymentId !== null
            );
            console.log("after filter", resp.data);
            if (resp.data.length === 0) {
              // ! to check already existing requests?
              // !todo: insert change unit request with status & lead confirmation as 'Accepted' (from service function)
              changeAllotedUnit(
                loggedInUser.userId,
                ownedUnitData.allotmentPaymentId,
                changeUnitData.description,
                "Accepted",
                changeUnitData.unitId,
                null,
                changeUnitData.bookingAmt,
                ownedUnitData.bookingAmt,
                ownedUnitData.unitId,
                ownedUnitData.allotmentStatus,
                data?.leadstatus,
                selectedAllotment?.pricingType === "preselect" ? true : false,
                ownedUnitData?.paymentPlanId,
                selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan?.title === "none" ? null : selectedProjectPaymentPlan?.paymentPlanId
              ).then((resp) => {
                // !todo: update inventory status for owned & changed units
                // ? unit status to be updated 1st for snapshot listener in allotment page
                // ! update leadId here
                // !todo: handle case for merged
                updateInventoryStatus(
                  changeUnitData.unitId,
                  ownedUnitData?.paidAmount !== 0 ?
                    changeUnitData?.bookingAmt?.total > ownedUnitData?.paidAmount ? paymentPendingInventoryStatus :
                      ownedUnitData?.kycFormFilled ?
                        kycDoneInventoryStatus : kycPendingInventoryStatus :
                    paymentPendingInventoryStatus,
                  selectedLeadId
                ).then(async (unitResp) => {
                  // !todo: update allotment status for owned & changed units
                  // !todo: add inventory logs for owned & changed units
                  // !todo: get status string from id of owned unit
                  const oldUnitInventoryPromise = checkForInventoryStatus(
                    ownedUnitData.unitId
                  );

                  // Audit row for the newly occupied unit. It is optional, so it no
                  // longer sits between us and the writes below. Previously
                  // EVERYTHING from here down -- the ChangeUnitRequests update, the
                  // freeing/zeroing of the old unit, the allotment repoint -- was
                  // nested inside this lookup's .then() with no .catch() anywhere,
                  // so one failed status lookup silently left the request at
                  // 'Accepted' with unitPriceAlreadyUpdated and oldUnitPrice never
                  // written, and nothing usable in Reprice Pending.
                  getInventoryStatusStringFromId(ownedUnitData.statusId)
                    .then((statusResp) => {
                      insertInventoryLogs({
                        userId: loggedInUser.userId,
                        leadId: selectedLeadId,
                        status: statusResp.data.status,
                        unitId: changeUnitData.unitId,
                      });
                    })
                    .catch((err) => {
                      console.error(
                        "change unit: inventory log for the new unit skipped",
                        err
                      );
                    });

                  // Stamp the request row the same way the Accept handler in
                  // AllAllotments.jsx does. unitPriceAlreadyUpdated=false is what
                  // puts the freed unit in Reprice Pending, and the Reprice Pending
                  // filter also requires requestPendingWithUserId to be null -- so
                  // pass it explicitly rather than relying on the insert.
                  // pricingType comes from the allotment actually being changed:
                  // `selectedAllotment` is null whenever the modal is opened from
                  // Leads > All (the handler there does setSelectedAllotment(null)),
                  // so reading it there decided the flag from nothing.
                  oldUnitInventoryPromise
                    .then((oldUnitInventoryRes) => {
                      const oldUnitPriceSnapshot = {
                        bsp: oldUnitInventoryRes?.data?.BSP,
                        gst: oldUnitInventoryRes?.data?.GST,
                        sdr: oldUnitInventoryRes?.data?.SDR,
                        total: oldUnitInventoryRes?.data?.totalCost,
                      };
                      const isPreselect =
                        (ownedUnitData?.pricingType ??
                          selectedAllotment?.pricingType) === "preselect";
                      return updateChangeUnitRequest(
                        "Accepted",
                        resp?.[0]?.changeUnitRequestId,
                        oldUnitPriceSnapshot,
                        isPreselect,
                        null
                      );
                    })
                    .catch((err) => {
                      console.error(
                        "change unit: could not stamp the request row",
                        err
                      );
                      errorTost(
                        "Unit changed, but the reprice entry was not updated. Contact your admin!"
                      );
                    });

                  getInventoryStatusId("Available").then((statusResp) => {
                    console.log("statusResp: ", statusResp);
                    if (statusResp.data.inventoryStatusId) {
                      // ??This update is for old allotment to make it available and its costing zeroed for reprice
                      freeAndZeroInventoryForChangeUnit(
                        ownedUnitData.unitId,
                        statusResp.data.inventoryStatusId
                      ).then((unitResp) => {
                        // !todo: update allotment status for owned & changed units
                        // !todo: add inventory logs for owned & changed units
                        oldUnitInventoryPromise.then((oldUnitInventoryRes) => {
                          const inventoryLogForOwnedUnit = {
                            userId: loggedInUser?.userId,
                            leadId: selectedLeadId,
                            status: "Available",
                            unitId: ownedUnitData.unitId,
                            oldUnitDetails: {
                              oldUnit: {
                                unitId: ownedUnitData.unitId,
                                bsp: oldUnitInventoryRes?.data?.BSP,
                                gst: oldUnitInventoryRes?.data?.GST,
                                sdr: oldUnitInventoryRes?.data?.SDR,
                                totalCost: oldUnitInventoryRes?.data?.totalCost,
                              },
                              lead: {
                                leadId: data?.leadId,
                                leadName: data?.leadname,
                                cuid: data?.leaddisplayid,
                              },
                            },
                          };
                          insertInventoryLogs(inventoryLogForOwnedUnit);
                        });
                        // First case paidAmount isless than neew bookingamount update AllotmentPayment and lead Status
                        updateAllotmentUnitId(
                          ownedUnitData.allotmentPaymentId,
                          changeUnitData.unitId,
                          changeUnitData.bookingAmt,
                          changeUnitData.unitCost,
                          ownedUnitData?.paidAmount !== 0 ? changeUnitData?.bookingAmt?.total > ownedUnitData?.paidAmount ? 'Partial Payment Done' : 'Payment Complete' : 'Payment Pending',
                          ownedUnitData?.paidAmount,
                          selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan?.title === "none" ? null : selectedProjectPaymentPlan?.paymentPlanId
                        ).then((allotmentresp) => {
                          if (allotmentresp?.data?.[0]?.CRM?.length > 0) {
                            const payload = {
                              oldUnitCost: changeUnitData.unitCost,
                              newUnitCost: { bsp: 0, sdr: 0, gst: 0, total: 0 },
                            }
                            updateCrmByAllotmentPaymentId(ownedUnitData.allotmentPaymentId, payload).then((crmResp) => { })
                          }
                          updateAllotmentTransactions(ownedUnitData.allotmentPaymentId,
                            changeUnitData.unitId).then((response) => {
                              let bucketingObj = {
                                allotmentPaymentId: ownedUnitData.allotmentPaymentId
                              }
                              bucketingForChangeUnit(bucketingObj).then((bucketingResp) => {
                                console.log({ bucketingResp });
                                if (bucketingResp.data.success) {
                                  // ??success
                                } else {
                                  errorTost(bucketingResp.data.message);
                                }
                              }).catch((err) => {
                                console.log(err);
                              });
                            }).catch((err) => {
                              console.log(err);
                            });
                          console.log(
                            "update allotment unitId resp: ",
                            allotmentresp
                          );
                          // !todo: update lead status
                          // Done
                          updateLeadAllStatus(data?.leadId, ownedUnitData?.paidAmount !== 0 ? changeUnitData?.bookingAmt?.total > ownedUnitData?.paidAmount ?
                            'Allotment Partial Payment Done' : 'Allotment Payment Complete' : 'Allotment Payment Pending').then((updateLeadStatus) => {
                            }).catch((err) => {
                              console.log(err, 'err while changing unit');
                            })
                          // console.log(updateLeadStatus);
                          // !todo: add lead log
                          let obj = {
                            leadId: data?.leadId,
                            // The timeline renders LeadLogs.leadStatus as the bold heading
                            // with `message` underneath, so this has to name the ACTION,
                            // not the resulting payment state -- otherwise a unit change
                            // is indistinguishable from an ordinary payment entry. The
                            // lead's real status is still set by updateLeadAllStatus()
                            // just above. Same string the Accept handler in
                            // AllAllotments.jsx writes, so the timeline reads the same
                            // whichever route the change took.
                            leadStatus: `Change Unit Done`,
                            // Who did this, in both places it belongs: the userId column
                            // (queryable, survives any wording change) and the message
                            // (what the Timeline actually shows). On this path one person
                            // raises and approves in a single click, so name them once as
                            // both rather than implying two actors.
                            userId: loggedInUser?.userId,
                            message: `Change Unit from ${ownedUnitData.projectName}, ${ownedUnitData.unitData.wingId.wingName}, ${ownedUnitData.unitData.floorNo}, ${ownedUnitData.unitData.unitNo} to ${changeUnitData.wingName}, ${changeUnitData.floorNo}, ${changeUnitData.unitNo} raised and accepted by ${loggedInUser?.name} (${loggedInUser?.roleId?.title}). Reason: ${changeUnitData.description}`,
                          };
                          addLeadLogs(obj)
                            .then((leadLog) => {
                              console.log(leadLog);
                            })
                            .catch((err) => {
                              console.log("leadlog", err);
                            });

                          // ! no need of lead confirmation
                          // sendMailAndSms(data?.leademail, "Requested to change Unit").then((resp) => {
                          //   if (resp.emailRes && resp.sms) {
                          //     successTost(`${data?.leadname} has requested for change unit successfully.Email and sms sent successfully`);
                          //   } else if (resp.emailRes === false && resp.sms) {
                          //     errorTost(`${data?.leadname} has requested for change unit successfully.Sms sent successfully,error while sending email `);
                          //   } else if (resp.emailRes && resp.sms === false) {
                          //     errorTost(`${data?.leadname} has requested for change unit successfully.Email sent successfully,error while sending sms `);
                          //   } else {
                          //     errorTost(`${data?.leadname} has requested for change unit successfully.Error while sending Email and Sms`);
                          //   }
                          // });
                          // successTost(
                          //   `${data?.leadname} has requested for change unit successfully`
                          // );
                          endSubmit();
                          successTost(
                            `Unit ${ownedUnitData.unitData.unitNo} changed`
                          );
                          returnRes(true);
                          handleClose();
                        });
                      });
                    } else {
                      // ! revert changed unit status?
                      endSubmit();
                    }
                  });
                });
              });
            } else {
              endSubmit();
              errorTost(
                "Request is already in process. Check with your admin!"
              );
            }
          });

        } else {
          // ??Raising requests
          // !  todo

          checkForChangeUnitStatus(
            ownedUnitData.unitId,
            ownedUnitData?.inventoryMergedId?.inventoryMergeId,
            ownedUnitData?.allotmentPaymentId
          ).then((resp) => {
            console.log(resp);
            resp.data = resp.data.filter(
              ({ allotmentPaymentId }) => allotmentPaymentId !== null
            );
            console.log("after filter", resp.data);
            if (resp.data.length === 0) {
              // ? get aprover userId
              getApproverInHierarchy(loggedInUser)
                .then((approverResp) => {
                  console.log("approverResp: ", approverResp);

                  // !todo: insert change unit request with lead confirmation as 'Accepted' (from service function)
                  changeAllotedUnit(
                    loggedInUser.userId,
                    ownedUnitData.allotmentPaymentId,
                    changeUnitData.description,
                    "Pending",
                    changeUnitData.unitId,
                    approverResp.userId,
                    changeUnitData.bookingAmt,
                    ownedUnitData.bookingAmt,
                    ownedUnitData.unitId,
                    ownedUnitData.allotmentStatus,
                    data?.leadstatus,
                    null,
                    ownedUnitData?.paymentPlanId,
                    selectedProjectPaymentPlan === null ? null : selectedProjectPaymentPlan?.title === "none" ? null : selectedProjectPaymentPlan?.paymentPlanId
                  ).then((resp) => {
                    // !!What Should be done
                    // !todo: update inventory status for owned & changed units
                    // ? unit status to be updated 1st for snapshot listener in allotment page
                    // !!Change unit should be onHold
                    updateInventoryStatus(
                      changeUnitData.unitId,
                      holdInventoryStatus,
                      selectedLeadId
                    ).then((unitResp) => {
                      // !todo: update allotment status for owned & changed units
                      // !todo: add inventory logs for owned & changed units
                      // const inventoryLogForOwnedUnit = {
                      //   userId: loggedInUser?.userId,
                      //   leadId: selectedAllotment.leadId,
                      //   status: "Available",
                      //   unitId: ownedUnitData.unitId,
                      // }
                      // insertInventoryLogs()
                      // insertInventoryLogs()
                      updateAllotmentPaymentStatus(
                        ownedUnitData.allotmentPaymentId,
                        "Change Requested",
                      ).then((allotmentresp) => {
                        // !todo: update lead status
                        updateLeadAllStatus(
                          data?.leadId,
                          "Unit Change Requested"
                        )
                          .then((updateLeadStatus) => {
                            console.log(updateLeadStatus);
                            // !todo: add lead log
                            let obj = {
                              leadId: data?.leadId,
                              leadStatus: `Change Unit Approval Pending by ${approverResp.name}`,
                              // The message named only the approver; the person who
                              // actually raised the request was recorded nowhere. Name
                              // them in the text and stamp the userId column too.
                              userId: loggedInUser?.userId,
                              message: `Change Unit request from ${ownedUnitData.projectName}, ${ownedUnitData.unitData.wingId.wingName}, ${ownedUnitData.unitData.floorNo}, ${ownedUnitData.unitData.unitNo} to ${changeUnitData.wingName}, ${changeUnitData.floorNo}, ${changeUnitData.unitNo} raised by ${loggedInUser?.name} (${loggedInUser?.roleId?.title}). Change Confirmation Pending by ${approverResp.name}. Reason: ${changeUnitData.description}`,
                            };
                            addLeadLogs(obj)
                              .then((leadLog) => {
                                console.log(leadLog);
                              })
                              .catch((err) => {
                                console.log("leadlog", err);
                              });
                          })
                          .catch((err) => {
                            console.log(err, "err while changing unit");
                          });
                        // ! no need of lead confirmation
                        // sendMailAndSms(data?.leademail, "Requested to change Unit").then((resp) => {
                        //   if (resp.emailRes && resp.sms) {
                        //     successTost(`${data?.leadname} has requested for change unit successfully.Email and sms sent successfully`);
                        //   } else if (resp.emailRes === false && resp.sms) {
                        //     errorTost(`${data?.leadname} has requested for change unit successfully.Sms sent successfully,error while sending email `);
                        //   } else if (resp.emailRes && resp.sms === false) {
                        //     errorTost(`${data?.leadname} has requested for change unit successfully.Email sent successfully,error while sending sms `);
                        //   } else {
                        //     errorTost(`${data?.leadname} has requested for change unit successfully.Error while sending Email and Sms`);
                        //   }
                        // });
                        endSubmit();
                        successTost(
                          `${data?.leadname} has requested for change unit successfully`
                        );
                        returnRes(true);
                        handleClose();
                      });
                    });
                  });
                })
                .catch((err) => {
                  console.error("change unit: raise failed", err);
                  endSubmit();
                  errorTost("Could not raise the request. Contact your admin!");
                });
            } else {
              endSubmit();
              errorTost(
                "Request is already in process. Check with your admin!"
              );
            }
          });
        }
      } else {
        endSubmit();
        offlineToast();
      }
    });
  }
  function closeModal() {
      endSubmit();
      setErrorMessage("");
    handleClose();
    setHelperText((pre) => {
      pre.projectName = "";
      pre.wingName = "";
      pre.floorNo = "";
      pre.unitNo = "";
      pre.paymentPlan = "";
      return { ...pre };
    });
    // setChangeUnitData((pre)=>{
    //   pre.wingName='';
    //   pre.
    // })
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  const handleGetPaymentPlan = (projectId, wingId, displayUnitType) => {
    getAllPaymentPlans(projectId, wingId, displayUnitType)
      .then((allPaymentPlans) => {

        setListOfProjectPaymentPlan([{ title: "none" }, ...allPaymentPlans.data,]);
      })
  }
  useEffect(() => {
    console.log("changeUnitData.projectName", changeUnitData.projectName)
    console.log("changeUnitData.selectedUnitId", changeUnitData.selectedUnitId)
    console.log("errorMessage", errorMessage)
    console.log("ownedUnitData?.isAllowed", ownedUnitData?.isAllowed)
    console.log("ownedUnitData?.projectName", ownedUnitData?.projectName)
    console.log("ownedUnitData?.isCrmTagged", ownedUnitData?.isCrmTagged)

  }, [changeUnitData]);
  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            closeModal();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(52, 64, 84, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.wrapperHeader}>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.2rem"} height={"1.2rem"} />
            </span>
            <div>Change Unit</div>
          </div>
          <div className={cssClasses.wrapperContent}>
            <div className={cssClasses.wrapperFirstBlock}>
              <div className={cssClasses.firstBlockTitle}>Alotted Unit</div>
              <div className={cssClasses.wrapperSecondBlock}>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    All Allotted Projects{" "}
                    <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={uniqBy(projectNameList, "label")}
                      selectedValue={changeUnitData.projectName}
                      onChangeSelect={(_value) => {
                        console.log(_value);
                        setHelperText((pre) => {
                          pre.projectName = "";
                          return { ...pre };
                        });
                        let selectedProject;
                        selectedProject = projectNameList.filter(
                          ({ value }) => _value === value
                        );
                        console.log(selectedProject);
                        setChangeUnitData((pre) => {
                          if (_value !== pre.projectName) {
                            pre.wingName = "";
                            pre.unitId = "";
                            pre.unitNo = "";
                            pre.bookingAmt = null;
                            pre.selectedUnitId = "";
                            pre.floorNo = "";
                          }
                          pre.projectName = _value;
                          pre.projectData = selectedProject[0];
                          pre.enablePaymentPlan = selectedProject[0]?.enablePaymentPlan
                          return { ...pre };
                        });

                        const allotedWing = getProjectWiseWings(
                          allotedData,
                          selectedProject[0]
                        );
                        console.log("Alotedwing", allotedWing)
                        setSelectedWingNameList([...allotedWing]);
                        // const selectedUnit =
                        if (ownedUnitData.isAllowed) {
                          setOwnedData((pre) => {
                            pre.unitId = "";
                            pre.isAllowed = false;
                            return { ...pre };
                          });
                        }
                        presentLoader()
                        getProjectDataByProjectId(selectedProject[0]?.value).then((resp) => {
                          setChangeUnitData((pre) => {
                            // if (_value !== pre.projectName) {
                            //   pre.wingName = "";
                            //   pre.unitId = "";
                            //   pre.unitNo = "";
                            //   pre.bookingAmt = null;
                            //   pre.selectedUnitId = "";
                            //   pre.floorNo = "";
                            // }
                            // pre.projectName = _value;
                            // pre.projectData = selectedProject[0];
                            pre.enablePaymentPlan = resp?.data[0]?.enablePaymentPlan
                            return { ...pre };
                          });
                          dismissLoader()
                        }).catch(err => {
                          dismissLoader()
                        })
                      }}
                      placeHolder={"Select Project"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.projectName}
                    />
                  </div>
                </div>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Selected Unit <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={selectedWingNameList}
                      selectedValue={ownedUnitData.unitId}
                      onChangeSelect={(value) => {
                        console.log(value);
                        setChangeUnitData((pre) => {
                          pre.selectedUnitId = value;
                          return { ...pre };
                        });
                        setHelperText((pre) => {
                          pre.selectedUnit = "";
                          return { ...pre };
                        });
                        let selectedUnit;
                        selectedUnit = allotedData.filter(
                          ({ unitId }) => value === unitId.unitId
                        );
                        console.log("------>", selectedUnit);
                        const eligibility = computeChangeUnitEligibility(selectedUnit[0]);
                        const isAllowed = eligibility.isAllowed;
                        setOwnedData((pre) => {
                          pre.allotmentPaymentId =
                            selectedUnit[0]?.allotmentPaymentId;
                          pre.paymentPlanId =
                            selectedUnit[0]?.paymentPlanId;
                          pre.projectId = selectedUnit[0]?.unitData?.projectId?.projectId
                          pre.isCrmTagged = eligibility.isCrmTagged;
                          pre.b2bBlocked = eligibility.b2bBlocked;
                          pre.projectName = selectedUnit[0]?.unitData?.projectId?.projectName
                          pre.unitId = selectedUnit[0]?.unitId.unitId;
                          pre.unitData = selectedUnit[0]?.unitData;
                          pre.inventoryMergedId =
                            selectedUnit[0]?.inventoryMergedId;
                          pre.bookingAmt = selectedUnit[0]?.bookingAmt;
                          pre.paidAmount = selectedUnit[0]?.paidAmount;
                          pre.statusId =
                            selectedUnit[0]?.unitData?.inventoryStatusId;
                          pre.isAllowed = isAllowed;
                          pre.allotmentStatus = selectedUnit[0]?.status;
                          pre.pricingType = selectedUnit[0]?.pricingType;
                          pre.kycFormFilled = selectedUnit[0]?.kycFormFilled;
                          console.log("after changes ownedData", selectedUnit[0])
                          pre.hundredB2bRes = selectedUnit[0]?.["100B2bRes"]
                          pre.gstB2bRes = selectedUnit[0]?.gstB2bRes
                          pre.SdrB2bRes = selectedUnit[0]?.SdrB2bRes
                          return { ...pre };
                        });
                        console.log('selectedUnitId', selectedUnit[0].unitId.unitId);
                        setSelectedLeadId(selectedUnit[0]?.leadId)
                        checkForPendingRequestOnAllotment(
                          selectedUnit[0]?.allotmentPaymentId
                        );
                        getAllInventory(
                          selectedUnit[0]?.unitData.projectId.projectId,
                          selectedUnit[0]?.unitId.unitId
                        );
                      }}
                      placeHolder={"Select Unit"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.selectedUnit}
                    />
                  </div>
                </div>
              </div>
              <div
                className={cssClasses.wrapperSecondBlock}
                style={{ marginTop: "2rem" }}
              >
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Booking Amount <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <div className={cssClasses.blockLabel}>
                      ₹ {numberWithCommas(ownedUnitData?.bookingAmt?.total)}
                    </div>
                  </div>
                </div>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Paid Booking Amount <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <div className={cssClasses.blockLabel}>
                      ₹ {numberWithCommas(ownedUnitData.paidAmount)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={cssClasses.wrapperFirstBlock}>
              <div className={cssClasses.firstBlockTitle}>Change To</div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Wing <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={wingNameList}
                      selectedValue={changeUnitData.wingName}
                      onChangeSelect={(value) => {
                        setChangeUnitData((pre) => {
                          pre.wingName = value;
                          pre.unitNo = "";
                          pre.floorNo = "";
                          pre.bookingAmt = null;
                          return { ...pre };
                        });
                        setHelperText((pre) => {
                          pre.wingName = "";
                          return { ...pre };
                        });
                        filterFloors(value);
                        setErrorMessage("");
                      }}
                      placeHolder={"Select Wing"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      disable={!ownedUnitData.isAllowed}
                      helperText={helperText.wingName}
                    />
                  </div>
                </div>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Floor <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={sortBy(floorList, (fl) => {
                        return isNaN(parseInt(fl.floorNo.split(" ")[1]))
                          ? 0
                          : parseInt(fl.floorNo.split(" ")[1]);
                      }).map((element, id) => {
                        return {
                          label: element.floorNo,
                          value: element.floorNo,
                        };
                      })}
                      selectedValue={changeUnitData.floorNo}
                      onChangeSelect={(value) => {
                        setChangeUnitData((pre) => {
                          pre.floorNo = value;
                          pre.bookingAmt = null;
                          pre.unitNo = "";
                          return { ...pre };
                        });
                        setHelperText((pre) => {
                          pre.floorNo = "";
                          return { ...pre };
                        });
                        setErrorMessage("");
                        filterUnit(value, changeUnitData.wingName);
                      }}
                      placeHolder={"Select Floor"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.floorNo}
                      disable={!ownedUnitData.isAllowed}
                    />
                  </div>
                </div>
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Unit <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={uniqBy(sortBy(unitNoList, "unitNo"), "unitNo").map(
                        (element, id) => {
                          return {
                            label: element.unitNo,
                            value: element.unitNo,
                          };
                        }
                      )}
                      selectedValue={changeUnitData.unitNo}
                      disable={!ownedUnitData.isAllowed}
                      onChangeSelect={(value) => {
                        setHelperText((pre) => {
                          pre.unitNo = "";
                          return { ...pre };
                        });
                        let selectedUnitId;
                        selectedUnitId = inventoryArray.filter(
                          ({ unitNo }) => value === unitNo
                        );
                        selectedUnitId = selectedUnitId.filter(
                          (el) => changeUnitData.wingName === el.wingId.wingName
                        );

                        console.log({ selectedUnitId });
                        // ? get booking amount for selected unit type
                        handleGetPaymentPlan(
                          selectedUnitId[0].projectId,
                          selectedUnitId[0].wingId.wingId,
                          selectedUnitId[0].displayUnitType
                        )
                        getChangedBookingAmount(
                          selectedUnitId[0].projectId,
                          selectedUnitId[0].wingId.wingId,
                          selectedUnitId[0].inventoryTypeId
                        ).then((bookingAmt) => {
                          if (bookingAmt) {
                            setChangeUnitData((pre) => {
                              pre.unitNo = value;
                              pre.unitId = selectedUnitId[0].unitId;
                              pre.bookingAmt = {
                                ocr: bookingAmt.OCR,
                                gst: bookingAmt.GST,
                                sdr: bookingAmt.SDR,
                                total: bookingAmt.TOTAL,
                              };
                              return { ...pre };
                            });

                            getDataFromInventory(
                              selectedUnitId[0].projectId,
                              selectedUnitId[0].wingId.wingId,
                              selectedUnitId[0].inventoryTypeId,
                              selectedUnitId[0].unitId
                            )
                              .then((inventoryRes) => {
                                console.log(
                                  "inventoryRes",
                                  inventoryRes.data[0]
                                );
                                if ((
                                  inventoryRes.data[0].totalCost === null ||
                                  inventoryRes.data[0].totalCost === "" ||
                                  inventoryRes.data[0].totalCost === undefined ||
                                  inventoryRes.data[0].totalCost === 0) && selectedAllotment?.pricingType !== "preselect"
                                ) {
                                  setErrorMessage(
                                    "as Unit price not added of Changing Unit. Contact your admin!"
                                  );
                                } else if (
                                  inventoryRes.data[0].totalCost !== null
                                ) {
                                  setErrorMessage("");
                                  // !!Don't add OCR in unitCost
                                  setChangeUnitData((pre) => {
                                    pre.unitCost = {
                                      gst: inventoryRes.data[0]?.GST,
                                      sdr: inventoryRes.data[0]?.SDR,
                                      total: inventoryRes.data[0]?.totalCost,
                                      bsp: inventoryRes?.data[0]?.BSP,
                                    };
                                    return { ...pre };
                                  });
                                  // if (
                                  //   changeUnitData.bookingAmt?.total -
                                  //     ownedUnitData.bookingAmt?.total <
                                  //   0
                                  // ) {
                                  //   setErrorMessage(
                                  //     `to ${selectedUnitId[0]?.wingId?.wingName}- ${selectedUnitId[0]?.unitNo}. Please cancel unit  ${ownedUnitData?.unitData?.wingId?.wingName} - ${ownedUnitData?.unitData?.unitNo}.`
                                  //   );
                                  // } else {
                                  //   setErrorMessage("");
                                  // }
                                  console.log({
                                    ocr: inventoryRes.data[0]?.OCR,
                                    gst: inventoryRes.data[0]?.GST,
                                    sdr: inventoryRes.data[0]?.SDR,
                                    total: inventoryRes.data[0]?.totalCost,
                                    bsp: inventoryRes.data[0]?.BSP,
                                  });
                                }
                              })
                              .catch((err) => {
                                console.log(err);
                              });
                          } else {
                            console.log("booking amount not added!");
                            setChangeUnitData((pre) => {
                              pre.unitNo = value;
                              pre.unitId = selectedUnitId[0].unitId;
                              pre.bookingAmt = {
                                ocr: 0,
                                gst: 0,
                                sdr: 0,
                                total: 0,
                              };
                              return { ...pre };
                            });
                            // errorTost('Booking amount not added. Contact your admin!');
                            setErrorMessage(
                              "as Booking amount not added. Contact your admin!"
                            );
                          }
                        });
                      }}
                      placeHolder={"Select Unit No"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.unitNo}
                    />
                  </div>
                </div>
                {changeUnitData?.enablePaymentPlan && <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Payment Plan <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%" }}>
                    <DropDown
                      list={listOfProjectPaymentPlan.map((element, id) => {
                        return {
                          label: element.title,
                          value: element.title,
                        };
                      })}
                      selectedValue={selectedProjectPaymentPlanId}
                      onChangeSelect={(value) => {
                        setHelperText((pre) => {
                          pre.paymentPlan = "";
                          return { ...pre };
                        });
                        setSelectedProjectPaymentPlanId(value);
                        let selectedProjectPricing =
                          listOfProjectPaymentPlan.filter(
                            (el) => value === el.title
                          );
                        setSelectedProjectPaymentPlan(
                          selectedProjectPricing[0]
                        );
                        presentLoader()
                        if (selectedProjectPricing[0]?.title === 'none') {
                          checkForInventoryStatus(changeUnitData?.unitId).then(resp => {
                            const payload = { ...changeUnitData }
                            payload.unitCost = {
                              "bsp": resp?.data?.BSP,
                              "gst": resp?.data?.GST,
                              "sdr": resp?.data?.SDR,
                              "total": resp?.data?.totalCost
                            }
                            setChangeUnitData(payload)
                            dismissLoader()
                          }).catch(err => {
                            dismissLoader()
                          })
                        } else {
                          getPaymentPlansPriceFromServer(selectedProjectPricing[0]?.paymentPlanId, changeUnitData?.unitId).then((resp) => {
                            const payload = { ...changeUnitData }
                            if (resp?.data?.length > 0) {
                              payload.unitCost = {
                                "bsp": resp?.data[0]?.BSP,
                                "gst": resp?.data[0]?.GST,
                                "sdr": resp?.data[0]?.SDR,
                                "total": resp?.data[0]?.totalCost
                              }
                            }
                            setChangeUnitData(payload)
                            dismissLoader()
                          }).catch(err => {
                            dismissLoader()
                          })
                        }
                      }}
                      placeHolder={"Select Payment Plan"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      helperText={helperText.paymentPlan}
                    />
                  </div>
                </div>}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                  width: "100%",
                  alignItems: "center",
                  marginTop: "2rem",
                }}
              >
                <div className={cssClasses.wrapperBlock}>
                  <div className={cssClasses.blockLabel}>
                    Booking Amount <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "100%", textAlign: "left" }}>
                    {changeUnitData.bookingAmt && (
                      <div className={cssClasses.blockLabel}>
                        ₹ {numberWithCommas(changeUnitData.bookingAmt?.total)}
                      </div>
                    )}
                    {!changeUnitData.bookingAmt && (
                      <div className={cssClasses.blockLabel}>₹ -</div>
                    )}
                  </div>
                </div>
                {changeUnitData.bookingAmt?.total -
                  ownedUnitData.bookingAmt?.total >=
                  0 && (
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        Difference in booking Amount{" "}
                        <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%", textAlign: "left" }}>
                        {changeUnitData.bookingAmt && (
                          <div className={cssClasses.blockLabel}>
                            ₹{" "}
                            {numberWithCommas(
                              changeUnitData.bookingAmt?.total -
                              ownedUnitData.bookingAmt?.total
                            )}
                          </div>
                        )}
                        {!changeUnitData.bookingAmt && (
                          <div className={cssClasses.blockLabel}>₹ -</div>
                        )}
                      </div>
                    </div>
                  )}
                {changeUnitData.bookingAmt?.total - ownedUnitData.paidAmount >=
                  0 && (
                    <div className={cssClasses.wrapperBlock}>
                      <div className={cssClasses.blockLabel}>
                        Amount to be paid <span style={{ color: "red" }}> *</span>
                      </div>
                      <div style={{ width: "100%", textAlign: "left" }}>
                        {changeUnitData.bookingAmt && (
                          <div className={cssClasses.blockLabel}>
                            ₹{" "}
                            {numberWithCommas(
                              changeUnitData.bookingAmt?.total -
                              ownedUnitData.paidAmount
                            )}
                          </div>
                        )}
                        {!changeUnitData.bookingAmt && (
                          <div className={cssClasses.blockLabel}>₹ -</div>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div
              className={cssClasses.wrapperBlock}
              style={{ width: "100%", textAlign: "left" }}
            >
              <div
                className={cssClasses.blockLabel}
                style={{ width: "100%", textAlign: "left" }}
              >
                Description: <span style={{ color: "red" }}> *</span>
                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <TextField
                    value={changeUnitData.description}
                    disabled={!changeUnitData.bookingAmt ||
                      !ownedUnitData.isAllowed ||
                      errorMessage !== ""}
                    maxRows={4}
                    onChange={(e) => {
                      const raw = e.target.value.trimStart();
                      // Letters, numbers and spaces only -- no dots or other
                      // punctuation. Sanitised rather than rejected outright so a
                      // paste keeps its valid characters instead of being dropped
                      // whole, and so the 200-char cap still applies to what is
                      // actually stored.
                      const clean = raw.replace(/[^A-Za-z0-9 ]/g, "");
                      if (clean.length <= 200) {
                        setChangeUnitData((pre) => {
                          pre.description = clean;
                          return { ...pre };
                        });
                      }
                      setHelperText((pre) => {
                        pre.description =
                          clean.length === 0
                            ? "Please enter description"
                            : clean !== raw
                              ? "Only letters, numbers and spaces are allowed"
                              : "";
                        return { ...pre };
                      });
                    }}
                    placeholder={"Type..."}
                    helperText={helperText.description}
                    error={helperText.description !== ""}
                    className={classes.TextFieldStyle}
                    InputProps={{
                      className: classes.inputStyle,
                    }}
                    inputProps={{ min: 0 }}
                    FormHelperTextProps={{ className: classes.helperText }}
                    multiline
                  />
                </div>
              </div>
            </div>
            <div className={cssClasses.wrapperBlock}>
              {selectedAllotment?.pricingType !== "preselect" && (hasPendingRequest || !ownedUnitData?.isAllowed || errorMessage !== "") && ownedUnitData?.projectName && !ownedUnitData?.b2bBlocked && (
                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <div
                    className={cssClasses.blockLabel}
                    style={{ width: "100%", textAlign: "left", color: "red" }}
                  >
                    {ownedUnitData?.projectName},
                    {/* {ownedUnitData?.unitData?.wingId?.wingName} - */}
                    {ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName} -
                    {ownedUnitData?.unitData?.unitNo} cannot be changed {'\n'}
                    {hasPendingRequest ? (
                      <span>
                        as a Change Unit request is already raised and pending
                        approval
                      </span>
                    ) : errorMessage === "" ? (
                      // Fixed text by request. Previously interpolated
                      // ownedUnitData?.allotmentStatus, which printed the allotment
                      // status even when that status was not the reason the change
                      // was blocked.
                      <span>as it is PreSelect Price Confirmation Pending</span>
                    ) : (
                      <span>{errorMessage}</span>
                    )}
                  </div>
                </div>
              )}
              {(!ownedUnitData?.isAllowed || errorMessage !== "") && ownedUnitData?.projectName && ownedUnitData?.b2bBlocked && (
                <div style={{ width: "100%", marginTop: "1rem" }}>
                  <div
                    className={cssClasses.blockLabel}
                    style={{ width: "100%", textAlign: "left", color: "red" }}
                  >
                    {ownedUnitData?.projectName},
                    {/* {ownedUnitData?.unitData?.wingId?.wingName} - */}
                    {ownedUnitData?.unitData?.wingId?.displayName ? ownedUnitData?.unitData?.wingId?.displayName : ownedUnitData?.unitData?.wingId?.wingName} -
                    {ownedUnitData?.unitData?.unitNo} cannot be changed as
                    CRM is tagged.Please contact your CRM.
                  </div>
                </div>
              )}
              {(ownedUnitData?.projectName === '' && ownedUnitData?.projectName === undefined) && (
                <span className={cssClasses.blockLabel}
                  style={{ width: "100%", textAlign: "left", color: "red" }}>{errorMessage}</span>
              )}
            </div>
          </div>
          <div className={cssClasses.wrapperFooter}>
            <div>
              <Button
                style={{
                  color: "#344054",
                  backgroundColor: "#ffffff",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Cancel"}
                clicked={closeModal}
              />
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={saveBtnTitle}
                clicked={() => {
                  save();
                }}
disable={
  !changeUnitData.bookingAmt ||
  !ownedUnitData.isAllowed ||
  hasPendingRequest ||
  isSubmitting ||
  errorMessage !== "" ||
  (selectedProjectPaymentPlanId === '' && changeUnitData?.enablePaymentPlan)
}


              />
            </div>
          </div>
        </Box>
      </Modal>
      {openAlertBox && (
        <ConfirmationAlert
          confirm={(e) => {
            confirmationRes(e);
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Continue"}
          close={() => setOpenAlertBox(false)}
          title={"Warning"}
          subTitle={`Are you sure you want to change unit?`}
          // subTitle={`Are you sure you want to change unit ${ownedUnitData?.projectName}, ${ownedUnitData?.unitData?.wingId?.wingName},${ownedUnitData?.unitData?.floorNo}, ${ownedUnitData?.unitData?.unitNo} to ${changeUnitData?.projectName}, ${changeUnitData?.wingName}, ${changeUnitData?.floorNo}, ${changeUnitData?.unitNo}`}
          open={openAlertBox}
        />
      )}
    </>
  );
}
